// extracted by mini-css-extract-plugin
export default {"productGallery":"qJ-z","inQuickShop":"rJ-z"};